"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreferentialLoans = void 0;
const GlobalEventName_1 = require("../GlobalEventName");
const PartyName_1 = require("../../parties/PartyName");
const Resources_1 = require("../../../Resources");
class PreferentialLoans {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.PREFERENTIAL_LOANS;
        this.description = 'Decrease M€ production 1 step for each set of 5 TR over 10 (max 5 sets), then reduced by influence. Gain 10 M€.';
        this.revealedDelegate = PartyName_1.PartyName.POPULISTS;
        this.currentDelegate = PartyName_1.PartyName.CENTRISTS;
    }
    resolve(game, turmoil) {
        game.getPlayers().forEach((player) => {
            const amount = Math.min(Math.floor((player.getTerraformRating() - 10) / 5), 5) - turmoil.getPlayerInfluence(player);
            if (amount > 0)
                player.addProduction(Resources_1.Resources.MEGACREDITS, -amount, { log: true });
            player.addResource(Resources_1.Resources.MEGACREDITS, 10, { log: true });
        });
    }
}
exports.PreferentialLoans = PreferentialLoans;
//# sourceMappingURL=PreferentialLoans.js.map